import { Directive, HostListener } from '@angular/core';
import { LoggingService } from './services/logging';

@Directive({
    selector: '[stop-click-propagation]',
    standalone: false
})
export class StopClickPropagationDirective {
    constructor(private log: LoggingService) {}
    @HostListener('click', ['$event'])
    public onClick(event: any): void {
        this.log.verbose({
            type: 'StopClickPropagationDirective:onClick',
            event
        });
        event.stopPropagation();
    }

    @HostListener('mousedown', ['$event'])
    public onMousedown(event: any): void {
        this.log.verbose({
            type: 'StopClickPropagationDirective:onMousedown',
            event
        });
        event.stopPropagation();
    }
}
